var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.151,
    height: 95.12,
    viewBox: "0 0 106.151 95.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#7fa6e1;}.c{fill:#e2b097;}.d{fill:#f1a34f;}.e{fill:#d86713;}.f{fill:#3c4ef1;}.g{fill:#1b2dc9;}.h{fill:#e8b241;}.i{fill:#f8d451;}.j{fill:#412013;}.k{fill:#fdf4df;}.l{opacity:0.4;}.m{fill:#6fd2cc;}.n{fill:#7fe1d3;}.o{opacity:0.8;}.p{opacity:0.6;}.q{fill:#e77d3b;}.r{fill:#d87131;}.s{fill:#b83dac;}.t{fill:#c751bb;}.u{fill:#da9f84;}.v{fill:#292f45;}.w{fill:#373c52;}.x{fill:#dfebfa;}.y{fill:#e1558b;}.z{fill:#d23e7d;}.aa{fill:#ae0c0c;}.ab{fill:#443a3e;}.ac{fill:#211a1d;}.ad{fill:#d41c1c;}.ae{fill:#d53535;}.af{fill:#39b566;}.ag{fill:#4cd57e;}.ah{fill:#6ce899;}.ai{fill:#269b50;}.aj{fill:#bde649;}.ak{fill:#a9d629;}.al{fill:#cef462;}.am{fill:#1db870;}.an{fill:#008d4b;}.ao{fill:#73f1b6;}.ap{fill:#973be7;}.aq{fill:#6adb49;}.ar{fill:#d38254;opacity:0.5;}.as{fill:#ffc197;}.at{fill:#40c219;}.au{fill:#ffd3b6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M693.932,40.81h0a23.058,23.058,0,0,1-1.485,2.609,27.635,27.635,0,0,1-2.4,3.131c-.032.038-.066.075-.1.112q-.453.513-.937,1.005c-.16.166-.324.33-.488.491a32.669,32.669,0,0,1-3.59,3.049c-.78.569-1.573,1.095-2.373,1.573l-.333.2q-.794.46-1.593.855a21.912,21.912,0,0,1-3.532,1.4q-.37.108-.732.182-.406.082-.8.127c-8.122.906-13.613-10.231-17.741-13.908-4.385-3.9-11.587-6.423-11.727-11.273-.168-5.719,4.822-8.533,22.472-13.032,23.079-5.882,26.142,9.877,26.911,14.236A15.222,15.222,0,0,1,693.932,40.81Z",
    transform: "translate(-597.34 -14.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M674.186,55.182c-5.479,0-9.711-5.365-13.146-9.721a35.969,35.969,0,0,0-3.683-4.248,41.146,41.146,0,0,0-4.7-3.412c-3.569-2.344-6.943-4.558-7.037-7.89-.088-3.011,1.283-5.107,4.574-7.007,3.245-1.874,8.609-3.688,17.927-6.063,8.262-2.105,14.812-1.649,19.469,1.358,5.878,3.794,7.093,10.653,7.487,12.9a15.092,15.092,0,0,1-1.555,9.266v.008a23.233,23.233,0,0,1-1.487,2.614,27.82,27.82,0,0,1-2.4,3.135c-.033.038-.066.075-.1.112-.3.34-.617.679-.938,1.007-.151.158-.318.324-.489.492a32.6,32.6,0,0,1-3.6,3.055c-.779.569-1.579,1.1-2.376,1.575l-.333.2c-.528.3-1.062.592-1.6.856a22,22,0,0,1-3.538,1.4c-.247.075-.494.133-.735.183-.272.056-.544.1-.806.127A8.453,8.453,0,0,1,674.186,55.182Zm3.245-39.563a37.959,37.959,0,0,0-9.293,1.3c-9.309,2.373-14.665,4.184-17.906,6.058-3.267,1.887-4.624,3.96-4.536,6.943.1,3.292,3.451,5.5,7,7.829a40.8,40.8,0,0,1,4.707,3.418A36.114,36.114,0,0,1,661.1,45.42c3.622,4.587,8.122,10.3,14.019,9.64.26-.028.528-.071.8-.126.239-.049.484-.11.729-.181a21.879,21.879,0,0,0,3.526-1.4c.533-.263,1.068-.551,1.591-.853.111-.064.222-.13.332-.2.8-.475,1.593-1,2.37-1.571a32.371,32.371,0,0,0,3.586-3.045c.171-.167.334-.332.488-.49.319-.328.635-.666.936-1.005.034-.037.066-.075.1-.112a27.838,27.838,0,0,0,2.4-3.126,23.116,23.116,0,0,0,1.478-2.6v-.008A15.026,15.026,0,0,0,695,31.126c-.4-2.246-1.6-9.08-7.454-12.857a18.242,18.242,0,0,0-10.114-2.651Z",
    transform: "translate(-596.897 -14.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M785.048,6.7c.189-4.633-3.694-6.7-7.665-6.7s-8.293,1.026-8.669,7.187c-.242,3.964,1.87,6.4,7.955,6.406a11.39,11.39,0,0,0,4.869-.9l3.04,2.7-1.493-3.736A6.86,6.86,0,0,0,785.048,6.7Z",
    transform: "translate(-710.687 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1008.817,253.81c0-.035.523-1.116.356-1.2s-.464-.071-.5.118A6.594,6.594,0,0,0,1008.817,253.81Z",
    transform: "translate(-932.553 -233.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M987.578,243.188a6.379,6.379,0,0,0-.4-2.047c-.272-.322-.83-.78-1.006-.766a1.724,1.724,0,0,0-.655,1.623,5.729,5.729,0,0,0,1.076,1.643Z",
    transform: "translate(-911.116 -222.236)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 1.859,
    height: 3.363,
    rx: 0.929,
    transform: "matrix(0.958, -0.287, 0.287, 0.958, 74.851, 16.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M990.524,213.752l-1.441.432a.177.177,0,0,1-.22-.118L988,211.183a.177.177,0,0,1,.118-.22l1.441-.432a.176.176,0,0,1,.22.119l.864,2.882A.177.177,0,0,1,990.524,213.752Z",
    transform: "translate(-913.435 -194.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M992.5,230.134s.662-1.018.823-.961c.231.081-.6,1.373-.6,1.373s.616-.965.712-.893c.219.165-.13.772-.475,1.237,0,0,.619-.567.639-.465.071.358-.679,1.225-.679,1.225l-.419-.958Z",
    transform: "translate(-917.603 -211.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M985.92,225.788a23.354,23.354,0,0,1,.263-2.326c.069.23.234,1.505.234,1.505Z",
    transform: "translate(-911.52 -206.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1008.943,202.785a18.034,18.034,0,0,1-.83,4.777c-.6,1.685-1.637,3.052-3.412,2.547-.181-.052-.357-.107-.528-.167h0a8.122,8.122,0,0,1-4.773-4.132,1.85,1.85,0,0,1,1.047-.6,36.7,36.7,0,0,1,4.121,1.434c.738.151,1.334-3.907,1.811-5.313s2.443-2.037,2.443-2.037Z",
    transform: "translate(-923.983 -184.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1066.639,283.627l-.07,1.9c-.6,1.685-1.637,3.052-3.412,2.547-.181-.052-.357-.107-.528-.167.057.008,1.143.151,1.6-.3.467-.468.419-2.018,1.283-3.051S1066.639,283.627,1066.639,283.627Z",
    transform: "translate(-982.441 -262.221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1046.922,392.207a7.183,7.183,0,0,1-2.193,3.788,8.318,8.318,0,0,0-1.146,1.038l-.333.2q-.795.46-1.593.855a21.917,21.917,0,0,1-3.532,1.4q-.37.108-.732.182-.406.082-.8.127a73.854,73.854,0,0,1,4.144-9.515c.41-.809.673-1.306.673-1.306s1.5-.339,2.951-.5a7.128,7.128,0,0,1,2.25,0C1047.354,388.67,1047.405,390.4,1046.922,392.207Z",
    transform: "translate(-958.366 -359.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1113.054,372.13q-.453.513-.937,1.005c-.16.166-.324.33-.488.491a32.663,32.663,0,0,1-3.59,3.049c-.78.569-1.573,1.095-2.373,1.573-.111.066-.222.131-.333.2q-.794.46-1.593.855c.645-2.241,1.306-4.595,1.856-6.565.333-1.195.624-2.25.845-3.052.278-1.008.445-1.621.445-1.621l3.8,1.921,2.317,1.171A5.426,5.426,0,0,1,1113.054,372.13Z",
    transform: "translate(-1020.449 -340.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1097.7,204.723a44.844,44.844,0,0,1-.645,4.985c-.032.038-.066.075-.1.112q-.453.513-.937,1.005a8.875,8.875,0,0,1-1.577.27h0a10.76,10.76,0,0,1-1.534.016,13.041,13.041,0,0,1-3.409-.69,17,17,0,0,1-2.779-1.242l-.038-.021s-.914-.755.209-3.954a15.866,15.866,0,0,0,.521-2.017c.208-1.024.4-2.219.6-3.505.328-2.1.679-4.434,1.179-6.668,0,0,.3-.1.8-.2a13.248,13.248,0,0,1,2.766-.311h0a7.9,7.9,0,0,1,2.462.361l.034.011a2.067,2.067,0,0,1,.292.124l.027.014c1.722.906,1.558,3.906,1.918,7.018.035.308.075.617.124.924A17.961,17.961,0,0,1,1097.7,204.723Z",
    transform: "translate(-1004.356 -177.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1108.54,79.055s2.3-3.737,4.075-1.811a3.109,3.109,0,0,1,1.828,2.107c.679,1.847-.377,3.477-1.085,3.213-.453-.168-.666.612-.666.612Z",
    transform: "translate(-1024.887 -70.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1157.85,62.761s.158-1.547,2.419-1.4c0,0-1.069.019-1.3.465a1.739,1.739,0,0,1,1.345-.257c.568.244.807,1.306.776,1.643s-.466,1.394-.847,1.448a1.781,1.781,0,0,1-.881-.214Z",
    transform: "translate(-1070.476 -56.724)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1133.79,159.808a10.438,10.438,0,0,1-.783-2.968l-.136.048-2.282.8s.16.732.262,1.428c.042.284.075.792.091,1.236s.466.5.919.475C1133.065,160.776,1133.731,160.323,1133.79,159.808Z",
    transform: "translate(-1045.273 -145.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1130.54,158.274s.16.732.262,1.429a2.815,2.815,0,0,0,2.02-2.232Z",
    transform: "translate(-1045.226 -145.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1108.633,96.576a7.093,7.093,0,0,0,.563-2.142c.023-.679-.671-3.094-3.094-2.385a3.4,3.4,0,0,0-1.318.728c-.485.441-1.148,1.336.029,3.36l.33.693Z",
    transform: "translate(-1020.831 -84.983)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1106.716,110.667s3.117-.4,2.84-2.335-.061-3.294-2.063-3.122-2.283.966-2.348,1.635S1105.9,110.72,1106.716,110.667Z",
    transform: "translate(-1021.745 -97.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1117.41,101.073s1.176,2.154,2.535,2.3a2.617,2.617,0,0,0,1.871-.284,3.739,3.739,0,0,1-1.525-2.012S1117.9,99.9,1117.41,101.073Z",
    transform: "translate(-1033.087 -92.964)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1103,105.874a2.774,2.774,0,0,0-.647,1.115c-.084.516-.007,1.541-.308,1.549,0,0-.865-1.453-.269-2.43C1102.408,105.072,1103,105.874,1103,105.874Z",
    transform: "translate(-1018.441 -97.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1119.14,102.681s.95,2.293,2.709,2.817a5.75,5.75,0,0,1-2.226-2.776C1119.257,101.171,1119.14,102.681,1119.14,102.681Z",
    transform: "translate(-1034.687 -94.323)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1190.578,293.824a44.873,44.873,0,0,1-.644,4.985c-.032.038-.066.075-.1.112q-.453.513-.937,1.005a8.873,8.873,0,0,1-1.577.27h0a2.748,2.748,0,0,1,.151-3.426c1.44-1.81-.112-5.15.995-6.967.038-.063.075-.122.114-.177.73-1.056,1.426-.778,1.792-.5.036.308.075.617.125.924A17.936,17.936,0,0,1,1190.578,293.824Z",
    transform: "translate(-1097.23 -267.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1201.229,206.48c.315.552.629,1.139.927,1.724h0a23.069,23.069,0,0,1-1.485,2.609,21.068,21.068,0,0,1-1.754-1.854,27.868,27.868,0,0,1-2-4.2c-.44-1.066-.765-1.906-.765-1.906s-.938-6.1.285-5.759l.034.011a2.568,2.568,0,0,1,.292.124l.027.014C1199.689,198.675,1199.846,204.062,1201.229,206.48Z",
    transform: "translate(-1105.567 -182.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M924.439,504.242a30.732,30.732,0,0,1-2.129,3.685,22.833,22.833,0,0,1-4.409,4.937q-.3.248-.612.477c-.259.193-.521.377-.785.548l-.168.109c-5.407,3.433-7.971,2.633-9.826.629a21.65,21.65,0,0,1-2.026-2.792,12.3,12.3,0,0,0-2.92-3.413c-.061-.044-.123-.087-.186-.128-4.679-3.085-9.321-.528-11.756-3.956s.915-13.867.915-13.867-3.147-7.656,6.867-7.106,14.259-12.866,24.041-6.387C929.6,482.372,929.042,494.863,924.439,504.242Z",
    transform: "translate(-821.668 -439.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M909.74,515.944a4.762,4.762,0,0,1-3.658-1.736,18.823,18.823,0,0,1-1.852-2.529l-.178-.272a12.291,12.291,0,0,0-2.911-3.4c-.061-.045-.122-.087-.185-.128a12.725,12.725,0,0,0-6.423-1.819c-2.179-.183-4.061-.34-5.343-2.146-1.266-1.784-.95-5.47-.46-8.25a48.491,48.491,0,0,1,1.368-5.64c-.085-.217-1.155-3.07.287-5.1,1.093-1.539,3.32-2.228,6.626-2.047,4.31.235,7.521-2.1,10.628-4.363,4.036-2.939,7.848-5.715,13.432-2.018,8.13,5.384,7.665,17.818,3,27.317h0a30.88,30.88,0,0,1-2.131,3.689,22.945,22.945,0,0,1-4.418,4.946c-.2.166-.41.327-.614.478-.255.191-.52.377-.786.549l-.168.109C913.232,515.312,911.247,515.944,909.74,515.944Zm-13.734-33.021c-2.73,0-4.6.685-5.564,2.043-1.469,2.066-.286,5.011-.274,5.04l.005.013v.013c-.034.1-3.32,10.461-.921,13.834,1.263,1.777,3.128,1.933,5.288,2.113A12.794,12.794,0,0,1,901,507.811c.063.042.126.085.187.129a12.338,12.338,0,0,1,2.929,3.423l.179.272a19.058,19.058,0,0,0,1.844,2.519c1.607,1.736,4.024,3.018,9.778-.635l.167-.108c.266-.174.528-.358.783-.547.2-.151.408-.31.611-.476a22.8,22.8,0,0,0,4.4-4.929,30.841,30.841,0,0,0,2.126-3.68h0c4.647-9.471,5.116-21.862-2.978-27.222-5.538-3.667-9.33-.906-13.346,2.016-2.969,2.162-6.037,4.394-10.07,4.394q-.3,0-.6-.017-.518-.027-1-.028Z",
    transform: "translate(-821.267 -438.897)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "translate(72.301 62.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M966.9,825.494l-.012.139c-.01.112-.026.313-.058.679v0h0c0,.037-.007.076-.01.115-.06.7-1.1,1.341-2.089,1.686l-.053-.028a9.823,9.823,0,0,0-1.338-.58l.076-.127c.386-.679,1.607-.987,1.887-1.3s-.3-.315-.972-.007c-.546.249-.71.835-1.326,1.323a14.388,14.388,0,0,0-2.806-.537c-.262-.232-.428-.416-.428-.416.862-.044,2.094-.981,2.049-1.267s-2.09.494-2.44.528-1.145-.4-1.268-1.806,2.188-1.8,2.188-1.8,2.291,1.7,2.738,1.6-1.674-1.84-1.674-1.84a10.023,10.023,0,0,1,3.279-.143s.83,2.665,1.234,2.455-.852-2.322-.852-2.322a4.241,4.241,0,0,1,1.98.6C968.489,823.638,966.9,825.494,966.9,825.494Z",
    transform: "translate(-958.106 -821.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M973.15,852s6.272-.242,7.657,1.552a4.536,4.536,0,0,0,1.249,1.753l.147.4s-1.087-1.146-1.476-1.215C980.727,854.486,981.335,852.264,973.15,852Z",
    transform: "translate(-972.015 -849.695)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1086.821,893.994a3.937,3.937,0,0,1,1.44,2.775l-.245.023a6.371,6.371,0,0,0-1.208-2.559C1086.031,893.514,1086.821,893.994,1086.821,893.994Z",
    transform: "translate(-1076.779 -888.389)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(87.856 54.421)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1165.892,727.713s-2.53-1.417-1.349-3.34a5.029,5.029,0,0,1,1.957-1.485s-.54,2.868,0,2.936.371-3.239.371-3.239,2.665-1.283,3.711-1.181c0,0-1.653,2.8-1.113,2.733s2.4-2.9,2.4-2.9,2.733-.506,3.169,1.114-.27,2.429-.675,2.53-3,.068-2.935.405,1.822.877,2.8.574c0,0-1.08,2.665-2.5,2.53s-1.856-1.012-2.732-1.079-1.518.168-1.08.4,1.923.075,2.632.679,1.283.973-.034,1.244-3.678.1-4.15-.911Z",
    transform: "translate(-1164.228 -721.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1185.9,743.62s-7.086,2.292-7.9,4.858a5.38,5.38,0,0,1-.675,2.463v.506a7.367,7.367,0,0,1,1.147-1.957S1176.892,747.263,1185.9,743.62Z",
    transform: "translate(-1176.341 -741.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1169.225,836.787a4.674,4.674,0,0,0-.469,3.68l.281-.075a7.52,7.52,0,0,1,.3-3.344C1169.913,835.929,1169.225,836.787,1169.225,836.787Z",
    transform: "translate(-1168.237 -827.771)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(73.258 50.381)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M983.018,676.27s3.336-1.868,1.779-4.4a6.617,6.617,0,0,0-2.58-1.957s.712,3.781,0,3.87-.489-4.27-.489-4.27-3.514-1.69-4.892-1.557c0,0,2.179,3.692,1.468,3.6s-3.158-3.825-3.158-3.825-3.6-.667-4.181,1.468.355,3.2.89,3.335,3.958.089,3.869.534-2.4,1.156-3.692.755c0,0,1.423,3.514,3.292,3.335s2.446-1.334,3.6-1.423,2,.226,1.423.534-2.536.1-3.471.9-1.69,1.283.044,1.639,4.848.133,5.47-1.2Z",
    transform: "translate(-970.783 -667.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M995,697.23s9.34,3.025,10.407,6.4a7.091,7.091,0,0,0,.89,3.245v.672a9.851,9.851,0,0,0-1.509-2.58S1006.875,702.033,995,697.23Z",
    transform: "translate(-993.173 -694.997)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1139.249,820.044a6.162,6.162,0,0,1,.62,4.85l-.371-.1s.359-2.933-.394-4.408S1139.249,820.044,1139.249,820.044Z",
    transform: "translate(-1126.124 -808.159)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1071.394,770.361l-.02.075h0q-.389,1.424-.905,2.812c-.052.141-.1.282-.16.423h0q-.334.866-.712,1.705-.226.5-.463.981a31.152,31.152,0,0,1-1.841,3.252h0q-.14.218-.287.433a22.833,22.833,0,0,1-4.409,4.937c-.177.144-.355.285-.534.419l-.075.058c-.259.193-.521.377-.785.548q-.084.056-.167.109c-4.661,2.96-7.21,2.773-9.013,1.381l-.156-.125a6.757,6.757,0,0,1-.656-.627h0l-.016-.018a14.473,14.473,0,0,1-1.33-1.746c-.226-.338-.453-.684-.679-1.03-.06-.091-.12-.183-.182-.275a11.509,11.509,0,0,0-2.738-3.137c-.061-.044-.124-.088-.186-.128q-.393-.258-.784-.466l-.053-.028a15.921,15.921,0,0,1,1.886-2.188c.03-.03.062-.059.094-.088a2.913,2.913,0,0,1,.232-.184l.051-.036a5.012,5.012,0,0,1,.8-.445,12.258,12.258,0,0,1,2.214-.712l.121-.028c.8-.183,1.633-.321,2.4-.425q.242-.033.475-.061c.5-.062.964-.109,1.352-.143h.006l.288-.025c.3-.025.536-.041.7-.053h0c.141-.01.221-.014.226-.017s.312-.249.735-.622l.159-.142h0c.171-.151.354-.321.54-.5a13.786,13.786,0,0,0,1-1.05l.051-.061.112-.133.045-.053c.048-.057.1-.112.145-.166l.075-.08.075-.076.007-.008q.115-.124.226-.241c.036-.038.075-.075.111-.112l.054-.055.055-.054.1-.094.091-.085.081-.076c.126-.116.251-.226.373-.328l.075-.06c.048-.041.1-.075.145-.118.1-.075.192-.151.286-.216.023-.017.046-.035.07-.051.07-.051.14-.1.208-.143h0c.044-.029.088-.058.13-.084l.034-.022.1-.063.1-.059.055-.032c.034-.02.069-.039.1-.058l.045-.025.059-.032.086-.046c.043-.023.087-.045.13-.065l.061-.03.085-.04h0l.1-.045a5.359,5.359,0,0,1,1.072-.352l.082-.016q.075-.015.145-.025l.051-.008.029,0h.03c.075-.01.151-.016.211-.02h.136a1.393,1.393,0,0,1,.192.007q.5-.1.976-.173l.211-.033.231-.035.226-.032.226-.029.27-.033c.09-.011.171-.019.257-.027l.193-.019.129-.011h.016c.065-.006.13-.011.195-.015h0l.106-.007H1067c.035,0,.069,0,.1-.006h.089l.226-.009c.057,0,.113,0,.169,0h.422c.113,0,.226.005.336.011h.028l.091.005.117.008c.128.009.255.021.377.036a.649.649,0,0,1,.085.01l.11.015.094.014h.018l.188.032.185.036c.135.029.269.061.4.1.044.012.087.024.13.038l.075.023.075.024.063.021.082.029c.058.021.117.043.174.066l.131.054.088.039.052.024c.115.054.226.111.339.174h0A1.031,1.031,0,0,1,1071.394,770.361Z",
    transform: "translate(-966.363 -711.459)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1132.352,770.51h0q-.389,1.424-.906,2.812c-.052.141-.1.282-.16.423h0a4.929,4.929,0,0,1-.537.337,3.793,3.793,0,0,0-1.32,1.387c-.2.318-.4.66-.6,1h0a5.025,5.025,0,0,1-2.873,2.6c-2.8.82-7.546.729-10.249,3.64h0a1.632,1.632,0,0,1-2.654-.087,6.062,6.062,0,0,1-1.04-1.592c-.777-1.66-1.1-3.754-.515-4.7l.121-.028c.825-.19,1.65-.349,2.391-.479q.239-.042.466-.075c.557-.092,1.049-.166,1.434-.221l.125-.017h0l.151-.021.084-.012h.036c.278-.038.438-.058.444-.061s.173-.1.435-.267l.1-.065.178-.117c.275-.184.6-.415.93-.673a8.007,8.007,0,0,0,1.1-1.02l.051-.061.113-.133.045-.053c.048-.057.1-.112.145-.166l.076-.08.075-.075.007-.008q.115-.125.226-.241c.036-.038.075-.075.111-.112l.054-.055.055-.054.1-.094.09-.085.081-.075c.126-.116.251-.226.373-.328l.075-.06c.048-.041.1-.076.145-.118.1-.075.192-.151.286-.216.023-.017.046-.035.069-.051.07-.051.14-.1.208-.143h0c.044-.029.088-.058.13-.084l.034-.022.1-.063.1-.059.055-.032c.034-.021.069-.039.1-.058l.045-.025.059-.032.086-.046c.043-.023.087-.045.13-.065l.061-.03.085-.04h0l.1-.045a5.346,5.346,0,0,1,1.072-.352l.082-.016q.075-.015.145-.025l.051-.008.029,0h.029c.075-.01.151-.016.211-.02h.136a1.4,1.4,0,0,1,.192.007q.5-.1.976-.174l.211-.033.231-.035.226-.032.226-.029.27-.033c.09-.011.171-.019.257-.027l.193-.019.129-.011h.016c.065-.006.13-.01.195-.015h0l.106-.007h.022c.036,0,.069,0,.1-.006h.089l.226-.009c.057,0,.112,0,.169,0h.422c.112,0,.226.005.336.01h.028l.091.005.117.008c.128.009.255.021.377.036a.637.637,0,0,1,.085.01l.11.015.094.014h.018c.063.01.126.021.188.032l.185.036c.135.029.269.061.4.1.044.012.087.024.13.038l.075.023.075.024.063.021.081.029c.058.021.117.043.174.066l.131.054.088.039.052.024c.115.054.226.111.339.173h0A1.781,1.781,0,0,1,1132.352,770.51Z",
    transform: "translate(-1027.342 -711.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M1096.431,844.525h0a.8.8,0,0,1-.528.441,2.542,2.542,0,0,1-.27.048h0a31.307,31.307,0,0,1-5.707-.4,5.455,5.455,0,0,1-.14,2.347,6.485,6.485,0,0,0-.212,1.346c-.142,1.56-.193,3.9-.208,4.815a6.742,6.742,0,0,1-.656-.627h0l-.017-.018a14.48,14.48,0,0,1-1.33-1.746c-.226-.338-.453-.684-.679-1.03-.06-.091-.12-.183-.182-.275-.242-1.541-.475-3.221-.6-4.657v-.011c0-.031-.005-.061-.008-.091q-.007-.084-.013-.167c-.053-.665-.082-1.269-.076-1.772.013-.78.111-1.317.334-1.459a13.86,13.86,0,0,1,4.269-.554l.4-.015.6-.019h0c.443-.012.883-.021,1.307-.027h.238l.377,0h2.318c.414,0,.658.007.658.007s.09.346.181.842c.038.211.076.448.109.7h0A4.477,4.477,0,0,1,1096.431,844.525Z",
    transform: "translate(-1003.862 -777.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1187.221,757.53c0,.007-1.27,2.938-1.887,3.249s-2.849,2.864-3.327,2.818.558.389.558.389,3.9-1.783,4.124-1.895a8.472,8.472,0,0,0,1.59-3.064C1188.445,758.033,1187.221,757.53,1187.221,757.53Z",
    transform: "translate(-1092.694 -700.365)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1124.067,997.313l-.017-.018v-.005Z",
    transform: "translate(-1039.226 -922.032)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1265.823,649.167a3.386,3.386,0,0,1-1.4-2.495c-.161-.8-1.283-3.1-3.245-1.962a2.533,2.533,0,0,0-1.46.49c-.843.725-1.743,4-1.3,5.694h0a2.19,2.19,0,0,0,.1.307c.288.687.885.974,1.935.444-.051-.06.145-.173.466-.248a3,3,0,0,1,1.078-.053,2.244,2.244,0,0,1,.854.29,1.858,1.858,0,0,1,.559.509,2.326,2.326,0,0,1,.359.793,9.366,9.366,0,0,0,1.33-.483c.069-.031.138-.064.208-.1s.165-.084.247-.128l.151-.084C1266.8,651.5,1267.626,650.482,1265.823,649.167Z",
    transform: "translate(-1163.344 -595.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1108.582,858.5a29.993,29.993,0,0,1,1.713-2.477,6.673,6.673,0,0,0,.993-2.374h0c.021-.082.042-.165.063-.247h0c.347-1.4.528-2.762.634-2.786.066-.015.875.091,1.976.157,1.931.118,4.759.116,6.041-.862a1.924,1.924,0,0,0,.552-.62,1.346,1.346,0,0,0,.109-.994,4.384,4.384,0,0,0-1.555-1.967s-1.618.159-3.564.415l-.5.066c-1.172.159-2.421.35-3.482.558-.128.025-.252.05-.374.075h0c-.372.076-.715.159-1.013.241-.2.054-.377.109-.534.164a1.678,1.678,0,0,0-.658.347,19.26,19.26,0,0,0-1.392,3.773c-.384,1.251-.794,2.665-1.174,4.012a14.51,14.51,0,0,0,1.33,1.746l.017.018h0a6.749,6.749,0,0,0,.656.627Z",
    transform: "translate(-1022.927 -782.464)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1225.688,726.5a9.693,9.693,0,0,0-5.03-.552,1.933,1.933,0,0,0-1.509.954c-.583.955-.857,1.468-.857,1.468s.054.444.847.8c-.219.792.191,2.179-.192,2.717s-2.749,1.862-2.868,2.6c-.219,1.358,4.027,3.842,5.3,3.581C1225.031,737.319,1227.537,727.547,1225.688,726.5Z",
    transform: "translate(-1124.304 -671.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1287.457,654.342a5.163,5.163,0,0,0,.5-1.564,1.778,1.778,0,0,0-2.2-1.887,2.516,2.516,0,0,0-1,.489c-.377.307-.9.945-.108,2.49l.217.528Z",
    transform: "translate(-1187.318 -601.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1292.749,703.922c-.185.194-.114.84.748.794.566-.03,1.781-.727,1.668-1.207a5.973,5.973,0,0,1-.585-2.188l-.1.029-1.729.475s.081.549.122,1.069A2.242,2.242,0,0,1,1292.749,703.922Z",
    transform: "translate(-1195.117 -648.397)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M1293.77,702.111s.082.549.122,1.069a2.083,2.083,0,0,0,1.607-1.55Z",
    transform: "translate(-1196.139 -648.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1275,667.951s2.264-.562,1.886-1.962-.33-2.421-1.791-2.121-1.6.906-1.585,1.408S1274.4,668.061,1275,667.951Z",
    transform: "translate(-1177.409 -613.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1280.86,661.559a3.174,3.174,0,0,0,2.188,1.607,1.252,1.252,0,0,1,1.066.647,13.154,13.154,0,0,0-.665-2.545S1281.116,660.652,1280.86,661.559Z",
    transform: "translate(-1184.203 -611.178)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1271.735,667.26a3.957,3.957,0,0,0-.65.86,2.752,2.752,0,0,0,.392,1.879s-1.047-1.788-.693-2.559A.531.531,0,0,1,1271.735,667.26Z",
    transform: "translate(-1174.82 -616.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1155.887,838.073s-.453.475-.506.5a3.117,3.117,0,0,1-.856.1c-.182.045-.151-.068-.016-.159s.464-.054.329-.088a3.649,3.649,0,0,0-1.132-.1,1.018,1.018,0,0,1-.8-.066,3.56,3.56,0,0,1,1.283-.521c.291.017,1.127-.02,1.127-.02Z",
    transform: "translate(-1065.902 -774.504)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1304.5,751.808c-.052.141-.1.282-.16.423h0q-.335.865-.712,1.705a7.92,7.92,0,0,1-1.145.02c-.576-.026-1.2-.093-1.786-.171-1.255-.169-2.323-.395-2.323-.395l.1-.361.065-.226.191-.011.273-.016c.528-.032,1.429-.088,2.219-.142s1.46-.109,1.571-.14c.2-.055-.268-1.132-.8-2.226-.082-.167-.165-.334-.246-.5-.356-.713-.7-1.365-.859-1.665h0l-.092-.173,1.346-1.229.195-.178.2-.183.058.135c.115.267.386.906.7,1.7.076.191.151.39.227.6A26.655,26.655,0,0,1,1304.5,751.808Z",
    transform: "translate(-1200.391 -690.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1318.623,733.268a2.621,2.621,0,0,1,1.5,1.472c.588,1.172.8,1.741.8,1.741s-2.628,2.025-3.669,1.274S1317.659,733.24,1318.623,733.268Z",
    transform: "translate(-1217.52 -677.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1283.848,823.3a7.731,7.731,0,0,1-.631-.453,2.219,2.219,0,0,0-1.238-.187c0,.106.615.254.679.361s.441.548.761.548a.453.453,0,0,0,.428-.269Z",
    transform: "translate(-1185.238 -760.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M1223.337,783.939l3.958.719a.346.346,0,0,1,.257.215l1.256,3.637c.055.159-.068.281-.242.239l-3.916-.939a.349.349,0,0,1-.239-.2l-1.3-3.416A.182.182,0,0,1,1223.337,783.939Z",
    transform: "translate(-1130.801 -724.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M1218.788,783.092l3.958.719a.348.348,0,0,1,.258.216l1.255,3.637c.055.159-.068.281-.241.239l-3.917-.94a.349.349,0,0,1-.239-.2l-1.3-3.416A.183.183,0,0,1,1218.788,783.092Z",
    transform: "translate(-1126.596 -723.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1249.539,809.056c-.043-.13.03-.2.162-.168a.513.513,0,0,1,.316.3c.043.129-.029.2-.162.168A.514.514,0,0,1,1249.539,809.056Z",
    transform: "translate(-1155.234 -747.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1223,786.586c-.021-.063.015-.1.08-.082a.252.252,0,0,1,.155.151c.021.063-.015.1-.08.082A.252.252,0,0,1,1223,786.586Z",
    transform: "translate(-1130.7 -727.148)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1278.355,828.3a8.357,8.357,0,0,1-1.023-.041c-.2-.049-.727-.7-.588-.864.089-.1.577.084.81.084s.839-.335,1.251.355C1278.854,827.913,1278.355,828.3,1278.355,828.3Z",
    transform: "translate(-1180.375 -764.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1184.061,860.55l-.557,3.212h0q-.14.218-.287.433a22.827,22.827,0,0,1-4.409,4.937c-.177.144-.354.285-.534.419-1.182-.144-7.374-1.707-7.336-2.756h0a.741.741,0,0,1,.063-.248h0a8.607,8.607,0,0,1,2.609-2.629q.351-.256.732-.5h0c.26-.169.528-.333.8-.49h0a13.129,13.129,0,0,1,2.151-1,7.387,7.387,0,0,1,2.2-.446q.436-.014.82-.039c.491-.031.921-.075,1.3-.13a5,5,0,0,0,2.452-.761Z",
    transform: "translate(-1082.576 -795.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M874.439,474.412h0a2.15,2.15,0,0,1-.326-3.023l5-6.2a2.15,2.15,0,0,1,3.023-.325h0a2.149,2.149,0,0,1,.325,3.022l-5,6.208A2.149,2.149,0,0,1,874.439,474.412Z",
    transform: "translate(-807.711 -429.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M886.786,590.464h0a1.962,1.962,0,0,1-.086-2.775l2.976-3.169a1.962,1.962,0,0,1,2.775-.081h0a1.962,1.962,0,0,1,.086,2.775l-2.976,3.169a1.962,1.962,0,0,1-2.775.081Z",
    transform: "translate(-819.294 -539.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.115,698.808q-.02.744-.042,1.487c-.283,10.031-.8,19.727-11.088,17.565l-.089-.019q-.3-.063-.6-.142-.967-.242-2.043-.619c-.1-.035-.205-.075-.309-.11a13.126,13.126,0,0,0-2.374-.612,16.74,16.74,0,0,0-2.777-.2,36.168,36.168,0,0,0-6.148.711c-1.207.214-2.332.422-3.34.528q-.258.027-.5.045c-.222.016-.438.026-.646.028a6.916,6.916,0,0,1-.693-.023c-.158-.012-.312-.031-.46-.057a3.734,3.734,0,0,1-.421-.094,26.446,26.446,0,0,1-3.778-1.376,21.426,21.426,0,0,1-3.43-1.951,18.191,18.191,0,0,1-2.193-1.811,16.294,16.294,0,0,1-1.881-2.17h0q-.263-.365-.5-.738a14.639,14.639,0,0,1-1.845-4.227A14.361,14.361,0,0,1,.5,701.708h0a14.472,14.472,0,0,1,.226-2.83q.3-1.641.679-3.122.2-.762.417-1.482.335-1.1.722-2.113c3.664-9.549,12.765-14.567,21.286-10.383,12.131,5.956,16.307,1.79,19.719,6.885q.385.577.714,1.192c.113.211.22.425.322.643q.273.581.5,1.192.125.337.232.679.183.583.325,1.193.081.351.151.711.111.584.184,1.192c.026.213.049.427.069.645q.052.586.075,1.192Q46.137,698.042,46.115,698.808Z",
    transform: "translate(-0.46 -628.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.23,717.622a13.223,13.223,0,0,1-2.717-.309l-.057-.011-.032-.006c-.2-.043-.4-.091-.608-.143-.648-.163-1.336-.371-2.047-.62-.1-.036-.205-.076-.309-.111a13.122,13.122,0,0,0-2.367-.61,16.518,16.518,0,0,0-2.771-.2,35.937,35.937,0,0,0-6.141.71l-.294.052c-1.091.2-2.121.377-3.049.477-.17.018-.34.034-.506.046-.226.017-.445.026-.649.028a6.837,6.837,0,0,1-.7-.023c-.156-.012-.312-.031-.463-.057a4.123,4.123,0,0,1-.426-.1,26.62,26.62,0,0,1-3.782-1.378,21.583,21.583,0,0,1-3.436-1.956,18.3,18.3,0,0,1-2.2-1.811A16.37,16.37,0,0,1,2.8,709.428c-.177-.244-.345-.493-.5-.741A14.668,14.668,0,0,1,.45,704.445a14.422,14.422,0,0,1-.222-6.158c.2-1.084.424-2.135.679-3.124.13-.5.27-1,.417-1.484.22-.725.464-1.434.723-2.113,2-5.211,5.686-9.2,10.118-10.942a13.59,13.59,0,0,1,11.218.533,35.632,35.632,0,0,0,13.055,3.755c2.982.339,4.951.563,6.678,3.143.259.388.5.79.716,1.2.11.207.219.423.323.645.182.386.349.789.5,1.2.082.222.161.453.232.684.121.383.231.785.326,1.2.056.237.106.476.151.712.075.392.136.793.185,1.2.026.208.048.425.069.646.035.385.059.787.075,1.194.017.5.017,1,0,1.5-.007.253-.014.5-.021.755l-.02.729a64.81,64.81,0,0,1-.77,9.806c-.612,3.257-1.695,5.46-3.311,6.734A6.723,6.723,0,0,1,37.23,717.622Zm-10.782-2.091a16.408,16.408,0,0,1,2.66.2,13.216,13.216,0,0,1,2.381.614c.1.039.207.076.309.11.708.248,1.394.453,2.037.618.208.052.412.1.6.142l.032.006.056.011c3.009.633,5.3.291,6.991-1.046,3.669-2.892,3.873-10.112,4.052-16.482l.02-.73c.007-.252.014-.5.021-.755h0c.014-.5.014-1,0-1.5-.014-.406-.038-.806-.075-1.19-.02-.22-.043-.437-.068-.644-.049-.4-.111-.8-.184-1.19-.045-.235-.094-.473-.151-.709-.1-.408-.2-.808-.324-1.19-.075-.226-.151-.459-.232-.679-.151-.405-.315-.806-.5-1.19-.1-.22-.211-.436-.321-.641a13.588,13.588,0,0,0-.712-1.188c-1.707-2.551-3.557-2.761-6.623-3.111a35.678,35.678,0,0,1-13.078-3.763,13.51,13.51,0,0,0-11.157-.528c-4.407,1.731-8.08,5.7-10.07,10.894-.258.675-.5,1.383-.721,2.107-.146.482-.287.981-.416,1.481C.727,696.169.5,697.22.3,698.3a14.352,14.352,0,0,0,.223,6.125,14.611,14.611,0,0,0,1.838,4.221c.156.247.324.494.5.736a16.263,16.263,0,0,0,1.878,2.165,18.227,18.227,0,0,0,2.188,1.8A21.491,21.491,0,0,0,10.35,715.3a26.609,26.609,0,0,0,3.773,1.374,4.028,4.028,0,0,0,.417.094c.151.026.3.044.457.056a6.774,6.774,0,0,0,.69.023c.2,0,.419-.011.644-.028.165-.012.335-.027.5-.045.925-.1,1.954-.281,3.044-.476l.294-.052a35.986,35.986,0,0,1,6.155-.712Z",
    transform: "translate(0.003 -628.372)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M34.667,798.143l-.051-4.24H33.078v-3.627l-.072-.042h-3.13v.543h0v.377h0v.543h0v.377h0v.544h-.283v-2.85h-3v.361h0v.543h0v.478h0v.543h0v.377h0v.544h0v.347h0v.543h0v.347h0v.543h0v.328h0v.345h0v.038H23.22v3.109H21.958V799H20.6v-1.349h-2.45v-3.667h-.382v-.365h-.055v.365H15.807v-.365h-.054v.365h-.414v1.841l-2.056-.01v1.142H11.54v-7.037H6.377v7.537H4.8v-4.075H2.564q-.387,1.008-.722,2.113-.218.72-.417,1.482-.383,1.481-.679,3.122a14.472,14.472,0,0,0-.226,2.83h0a14.361,14.361,0,0,0,.453,3.311,14.639,14.639,0,0,0,1.844,4.232q.237.377.5.738h0A16.3,16.3,0,0,0,5.2,813.378a18.186,18.186,0,0,0,2.193,1.811,23.687,23.687,0,0,0,7.207,3.328,3.72,3.72,0,0,0,.421.094,7.548,7.548,0,0,0,1.8.051c2.657-.192,6.254-1.263,9.993-1.283a16.74,16.74,0,0,1,2.777.2,13.126,13.126,0,0,1,2.374.612c.1.038.207.075.309.11q1.076.377,2.043.619.309.076.6.142Z",
    transform: "translate(-0.478 -730.172)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 3.835,
    height: 1.192,
    transform: "translate(7.226 59.747)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 3.835,
    height: 1.192,
    transform: "translate(7.226 61.583)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 3.835,
    height: 1.192,
    transform: "translate(7.226 63.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 3.835,
    height: 1.192,
    transform: "translate(7.226 65.361)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 3.835,
    height: 1.192,
    transform: "translate(7.226 67.198)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(26.119 59.599)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(26.119 60.713)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(26.119 61.851)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(26.119 63.007)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(26.119 64.123)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(26.119 65.351)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(26.119 66.465)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(26.119 67.603)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(26.119 68.759)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(26.119 69.875)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(29.402 60.073)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(29.402 61.188)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(29.402 62.326)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(29.402 63.482)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(29.402 64.597)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(29.402 65.761)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(29.402 66.876)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(29.402 68.014)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(29.402 69.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.918,
    height: 0.724,
    transform: "translate(29.402 70.285)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 0.095,
    height: 1.478,
    transform: "translate(23.37 63.482)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 0.148,
    height: 2.862,
    transform: "translate(24.974 62.214)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 0.062,
    height: 0.527,
    transform: "translate(6.241 59.221)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 0.062,
    height: 0.527,
    transform: "translate(7.548 59.221)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 0.062,
    height: 0.527,
    transform: "translate(10.545 59.221)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 0.048,
    height: 0.407,
    transform: "translate(26.417 59.192)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 0.048,
    height: 0.407,
    transform: "translate(28.666 59.192)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 0.062,
    height: 0.527,
    transform: "translate(9.373 59.221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M460.134,799.91q-.02-.6-.075-1.192c-.02-.217-.042-.432-.069-.644q-.075-.608-.184-1.192-.068-.36-.151-.711-.143-.611-.325-1.193-.108-.345-.232-.679-.226-.612-.5-1.192c-.1-.218-.209-.432-.322-.643q-.328-.614-.714-1.192h-2v7.536h-1.7v-4.075H448.31V820.3q.309.075.6.142l.089.019c10.289,2.163,10.8-7.534,11.088-17.565q.021-.744.041-1.487Q460.158,800.646,460.134,799.91Z",
    transform: "translate(-414.479 -731.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M424.016,900.73v20.933l-.089-.019q-.3-.063-.6-.142-.967-.242-2.043-.619V900.73Z",
    transform: "translate(-389.489 -832.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M571.185,792.392h-.755V791.2h.043Q570.856,791.78,571.185,792.392Z",
    transform: "translate(-527.384 -731.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M571.957,816.752H570.38V815.56h1.081Q571.734,816.141,571.957,816.752Z",
    transform: "translate(-527.338 -754.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M572.515,841.583H570.38V840.39h1.811Q572.373,840.973,572.515,841.583Z",
    transform: "translate(-527.338 -776.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M572.848,866.812H570.38V865.62h2.284Q572.775,866.2,572.848,866.812Z",
    transform: "translate(-527.338 -800.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M572.992,891.189H570.38V890h2.537Q572.969,890.583,572.992,891.189Z",
    transform: "translate(-527.338 -822.838)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 0.065,
    height: 0.527,
    transform: "translate(42.002 59.182)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.789 54.469)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M359.979,842.835a2.389,2.389,0,0,1-.875,1.265,1.353,1.353,0,0,0-.561.408l-.32-.187-.383-.222s.009-.042.028-.112.047-.164.086-.271a.371.371,0,0,0,.045-.34.791.791,0,0,1,.065-.659c.123-.178.241-.617.315-.6.179.031-.088.635-.011.746a.133.133,0,0,0,.172.059h0c.5-.221,1.11-1.41,1.379-1.25A2.369,2.369,0,0,1,359.979,842.835Z",
    transform: "translate(-335.626 -832.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 2.997,
    height: 0.965,
    rx: 0.483,
    transform: "matrix(0.575, -0.818, 0.818, 0.575, 22.538, 10.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M370.435,841.987l.368.259a.075.075,0,0,0,.1-.018l1.637-2.329a.075.075,0,0,0-.018-.1l-.368-.259a.075.075,0,0,0-.1.019l-1.636,2.329A.075.075,0,0,0,370.435,841.987Z",
    transform: "translate(-347.241 -830.638)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M222.43,823.29s2.373,4.139,3.773,5.941a.894.894,0,0,0,1.242.171l3.6-2.68a1.552,1.552,0,0,1,.887.809s-2.582,5.261-5.125,5.485-6.112-6.306-6.112-6.306Z",
    transform: "translate(-208.825 -815.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M204.3,1008.75l-.023.29c-.063.785-.245,3.077-.453,5.728-.138,1.76-.287,3.677-.419,5.419-1.207.214-2.332.422-3.34.528q-.258.027-.5.045c-.222.016-.438.026-.646.028-.028-.415-.057-.852-.085-1.3h0c-.267-4.15-.567-9.6-.635-10.852-.009-.17-.014-.262-.014-.262l3.373.208h0Z",
    transform: "translate(-188.014 -986.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M204.3,1008.759l-.023.29c-.063.785-.245,3.077-.453,5.728,0,0-4.965,5.187-4.961,5.249l-.034-.533c-.018-.275-.035-.555-.054-.84-.252-4.016-.518-8.847-.581-10.012-.009-.17-.014-.262-.014-.262l3.374.208h0Z",
    transform: "translate(-188.014 -986.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M146.735,995.835s-.008.017-.02.051c-.231.575-2.355,5.857-4.452,10.359-.2.436-.408.866-.608,1.283-.158-.012-.312-.031-.46-.057a3.722,3.722,0,0,1-.421-.094A26.455,26.455,0,0,1,137,1006a6.54,6.54,0,0,1,.895-1.836,8.872,8.872,0,0,0,1.063-2.058c.022-.054.043-.109.064-.165a16.318,16.318,0,0,0,1.063-4.024c0-.066.006-.137.011-.21h0c.011-.193.025-.405.042-.628.059-.76.147-1.639.214-2.253.049-.463.085-.776.085-.776l4.556,1.29Z",
    transform: "translate(-131.451 -973.506)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M201.392,776.113c-1.542.487-4.212-.83-4.212-.83A4.006,4.006,0,0,0,198.525,772l1.192.961.81.654a9.592,9.592,0,0,1-.092,1.057c-.009.07-.019.143-.03.22a.579.579,0,0,0,.248.56A3.561,3.561,0,0,1,201.392,776.113Z",
    transform: "translate(-187.089 -768.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M216.978,785.067a9.589,9.589,0,0,1-.092,1.057c-.9-.151-1.916-1.606-1.916-1.606a2.875,2.875,0,0,1,1.2-.107Z",
    transform: "translate(-203.537 -779.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M210.422,741.274s-2.549.423-2.792-1.167-.729-2.608.888-2.943,2.025.222,2.234.734S211.078,741.123,210.422,741.274Z",
    transform: "translate(-196.508 -735.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M186.31,823.176a.249.249,0,0,1-.162.061,25.058,25.058,0,0,1-3.7.168,10.637,10.637,0,0,1-3.418-.986c-.151-.068-.5-.255-.494-.425.005-.186.024-.453.047-.8a42.569,42.569,0,0,0,.085-5.562c-.025-.437-.038-.871-.04-1.3-.011-3.18.619-5.977,1.887-6.924a4.094,4.094,0,0,1,1.383.549,2.157,2.157,0,0,0,1.523.221l.671.453a5.34,5.34,0,0,1,1.669,2.665,29.969,29.969,0,0,1,.5,4.945c.039.9.07,1.8.075,2.658v.031c.008.085.008.177.008.263C186.38,821.4,186.346,823.144,186.31,823.176Z",
    transform: "translate(-169.854 -800.943)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M179.15,879.1a42.566,42.566,0,0,0,.085-5.562c-.025-.437-.038-.871-.04-1.3.528-1.283.96-2.209.96-2.209h1.33S182.459,876.692,179.15,879.1Z",
    transform: "translate(-170.42 -858.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M74.545,1027.1l5.671.811a1.358,1.358,0,0,0,1.533-1.151l.351-2.459a1.358,1.358,0,0,0-1.152-1.533l-5.674-.809a1.358,1.358,0,0,0-1.533,1.152l-.351,2.458A1.358,1.358,0,0,0,74.545,1027.1Z",
    transform: "translate(-72.63 -999.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M72.106,1014.447h0a1.364,1.364,0,0,0-.939-.821h0c-.043-.01-.087-.019-.132-.025l-1.132-.161.075-.528a.444.444,0,0,0-.085-.333.453.453,0,0,0-.3-.175l-.2-.028-.1-.014-1.043-.151-.143-.02-.214-.031a.453.453,0,0,0-.507.377l-.075.528-1.95-.279a1.367,1.367,0,0,0-1.54,1.156l-.354,2.49a1.366,1.366,0,0,0,1.159,1.542l5.66.81a1.373,1.373,0,0,0,.294.009h0a1.356,1.356,0,0,0,.442-.112h0a1.362,1.362,0,0,0,.8-1.057l.355-2.49A1.347,1.347,0,0,0,72.106,1014.447Zm-4.433-1.867a.17.17,0,0,1,.14-.142.233.233,0,0,1,.051,0l.252.036h.01l.924.132.217.03.293.042a.17.17,0,0,1,.143.19l-.075.528-2.026-.289Z",
    transform: "translate(-63.463 -990.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M125.531,988.478a1.978,1.978,0,0,0-.309.555c-.08,1.075-.112,1.571-.878,1.592,0,0-.475.006-.484-.416,0,0,.325,0,.255-.589-.081-.679-.075-.687.377-1.042l.3-.489Z",
    transform: "translate(-119.302 -967.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M127.957,824.464a4.362,4.362,0,0,0,1,.056s1.422-4.393,1.606-4.795,4.226-5.152,4.226-5.152L133.1,810.36s-4.372,7.3-4.815,8.327a23.287,23.287,0,0,0-.988,5.5A1.827,1.827,0,0,0,127.957,824.464Z",
    transform: "translate(-122.483 -803.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M203.265,725.844s.261-.044.219-.4-.042-.83.251-.743.308.322.428.185.122-.714.994-.755,1.226.263,1.631.085.427-.792.427-.792a.7.7,0,0,1-.29.288s.679-.924-.106-1.558-1.582-.219-2.034-.191c-1,.06-1.643.12-1.969.776A3.6,3.6,0,0,0,203.265,725.844Z",
    transform: "translate(-192.142 -721.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M139.476,999.49s.287.3.3.424c.058.4.192.572.125.615-.139.091-.323-.205-.411-.471A1.207,1.207,0,0,1,139.476,999.49Z",
    transform: "translate(-133.715 -978.535)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M105.9,167.963c-2.4,3.176-9.289,13.583-20.579,8.754a18.777,18.777,0,0,0-4.593-2.2,26.176,26.176,0,0,0-8.678-1.37c-.562.005-1.122-.009-1.677-.042-7.615-.453-14.419-4.452-13.858-12.5.83-11.876,9.63-21.451,19.529-22.234s17.734,4.427,23.642,9.8S108.3,164.786,105.9,167.963Z",
    transform: "translate(-52.218 -127.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M90.608,177.615a14.64,14.64,0,0,1-5.771-1.257H84.83a18.949,18.949,0,0,0-4.583-2.192,26.126,26.126,0,0,0-8.666-1.368c-.562,0-1.127-.009-1.679-.042a20.646,20.646,0,0,1-6.458-1.376,12.88,12.88,0,0,1-4.968-3.374,10.3,10.3,0,0,1-2.467-7.8,25.772,25.772,0,0,1,6.372-15.3,19.976,19.976,0,0,1,13.192-6.97,25.935,25.935,0,0,1,13.336,2.592,43.011,43.011,0,0,1,10.333,7.211,23.585,23.585,0,0,1,6.234,10.741c1.167,4.061,1.161,7.552-.014,9.108-.126.167-.265.353-.415.557a28.111,28.111,0,0,1-7.1,7.2A13.411,13.411,0,0,1,90.608,177.615Zm-5.735-1.324c10.667,4.556,17.288-4.377,20.115-8.189.151-.2.29-.39.416-.557l.03.023-.03-.023c1.144-1.515,1.145-5.064,0-9.043A23.516,23.516,0,0,0,99.191,147.8c-5.061-4.6-13.015-10.623-23.613-9.784-10.121.8-18.684,10.552-19.494,22.2a10.211,10.211,0,0,0,2.448,7.741c2.423,2.757,6.463,4.434,11.374,4.724.551.032,1.115.046,1.675.041a26.2,26.2,0,0,1,8.692,1.379,19.03,19.03,0,0,1,4.6,2.2Z",
    transform: "translate(-51.751 -127.459)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M71.9,319.929q-.432,1.062-.772,2.178h0c.6,2.837,1.652,7.542,2.7,11.093.774,2.63,1.545,4.622,2.127,4.742.342.07,2.064.087,4.553.056,1.09-.013,2.327-.035,3.66-.066,1.381-.032,2.868-.076,4.394-.123,1.041-.034,2.1-.071,3.166-.112,1.466-.057,2.938-.121,4.368-.191,1.289-.064,2.545-.133,3.732-.206.247-.015.49-.03.73-.047,1.069-.069,2.074-.143,2.988-.221.857-.076,1.633-.151,2.307-.226q.659-.075,1.253-.158a26.9,26.9,0,0,0,2.717-.482c.7-.174,1.124-.357,1.2-.547a11.717,11.717,0,0,0-.565-2.681l-.018-.066c-.009-.03-.017-.061-.026-.092-1.248-4.522-4.129-12.863-6.235-13.49h0a.819.819,0,0,0-.245-.038h-.583c-2.367.008-8.951.057-12.463.089h0l-1.509.014-1.887.021h0l-.419.005h0l-1.585.02h0l-1.132.014h0l-1.235.017h0l-2.264.032-.723.011c-3.412.05-6.408.1-8.085.126-.046.109-.091.218-.136.328Z",
    transform: "translate(-65.762 -295.159)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M510.164,333.3s-3.21-12.3-3.442-13.331a.811.811,0,0,0-.742-.67c.564-.054.975-.059.975-.059a2.606,2.606,0,0,1,2.454,1.859c.778,2.424,2.323,7.079,3.773,11.63C513.108,332.73,510.164,333.3,510.164,333.3Z",
    transform: "translate(-467.797 -295.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M641.887,470.222a4.288,4.288,0,0,1-.711,1.759,35.049,35.049,0,0,1-5.726,6.445l.257-8.671.048-1.612h0A20,20,0,0,1,642,467.15c.029.352.047.693.051,1.023A9.879,9.879,0,0,1,641.887,470.222Z",
    transform: "translate(-587.497 -431.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M590.621,473.4a4.289,4.289,0,0,1-.711,1.759,35.049,35.049,0,0,1-5.726,6.445,17.507,17.507,0,0,1-3.16,2.1l-.735-7.65L580,473.065s.18-.086.5-.226h0l.044-.02h0l.34-.151c.193-.084.413-.177.655-.277.8-.331,1.846-.73,2.95-1.071,2.479-.767,5.26-1.238,6.293.029A9.874,9.874,0,0,1,590.621,473.4Z",
    transform: "translate(-536.232 -435.053)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M269.419,500.036a4.287,4.287,0,0,1-.711,1.759,35.05,35.05,0,0,1-5.726,6.445,17.508,17.508,0,0,1-3.16,2.1,12.837,12.837,0,0,1-6.792,1.441,13.8,13.8,0,0,1-2.527-.413q-.73-.188-1.487-.463-.439-.16-.888-.352a9.713,9.713,0,0,0-.9-.558,21.7,21.7,0,0,0-3.7-1.638c-.408-.139-.841-.275-1.3-.4a25.652,25.652,0,0,0-3.646-.743,27.066,27.066,0,0,0-3.735-.226q-.5,0-.991-.011l-.435-2.516-.847-4.9,1.207-.025,2.182-.039c.769-.014,1.648-.027,2.613-.041h.17c2.74-.038,6.151-.075,9.72-.084h3.773c1.7.006,3.4.02,5.031.044.7.01,1.384.023,2.056.036h.056l.327.008c1.233.027,2.415.062,3.514.106A60.829,60.829,0,0,1,269.419,500.036Z",
    transform: "translate(-215.029 -461.686)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M232.717,274.475a1.369,1.369,0,0,1-.256-.128h1.589s.08-.159-.906-.611a3.2,3.2,0,0,0-1.376-.034,1.726,1.726,0,0,1-.471,0,48.72,48.72,0,0,0-6.331-.534c-.634.016-5.141-.718-6.439-.458-.684.137-1.3.245-1.7.31a.424.424,0,0,1-.491-.381v0a11.252,11.252,0,0,0-.18-1.329l-1.585-.767c-.328.174-.666.052-.83.138.008.088.045.459.048.544a4.6,4.6,0,0,1-.1,1.147,1.744,1.744,0,0,1-1.253,1.3h-.008c1.189,1.023,7.235,2.806,7.337,2.283.126-.644,9.918-1.459,11.556-1.591a.848.848,0,0,1,.539.135.387.387,0,0,1,.1.087c.08.116.73.1.852.116S232.86,274.52,232.717,274.475Z",
    transform: "translate(-196.39 -250.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M274.851,299.671a1.856,1.856,0,0,1-.7,1.541c-.81.528-.6,1.9-.6,2.437l-3.471-4.968a17.014,17.014,0,0,1,2.113-.372,18.5,18.5,0,0,1,2.543.134A4.9,4.9,0,0,1,274.851,299.671Z",
    transform: "translate(-249.699 -275.782)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M328.07,460.235a13.8,13.8,0,0,1-2.527-.413q-.73-.188-1.487-.463c.349-1.639.872-4.528.441-5.532a5.991,5.991,0,0,1-.367-1.545,19.088,19.088,0,0,1-.118-2.668,40.593,40.593,0,0,1-6.7.131c-1.556-.168-2.871-.552-3.32-1.338a1.876,1.876,0,0,1-.2-.5,2.442,2.442,0,0,1,.446-1.892h0a5.562,5.562,0,0,1,.5-.662c.026-.03.053-.059.079-.088.168-.185.344-.359.52-.521a10.84,10.84,0,0,1,1.468-1.128s.3.054.8.151c1.358.263,4.166.841,6.35,1.5a10.172,10.172,0,0,1,2.641,1.079,2.758,2.758,0,0,1,.687,1.48,27.374,27.374,0,0,1,.555,4.187C328.083,455.262,328.081,458.926,328.07,460.235Z",
    transform: "translate(-290.067 -410.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M264.053,472.683q-.73-.188-1.487-.463-.439-.16-.888-.352a9.721,9.721,0,0,0-.9-.558c-.347-1.1-.835-2.473-1.509-4.064a6.653,6.653,0,0,1-.363-1.9c-.061-.773-.056-1.434-.089-1.447,0,0-2.487.021-5.128-.235a26.537,26.537,0,0,1-3.177-.478c-1.421-.32-2.555-.784-2.9-1.456a4.09,4.09,0,0,1-.269-.879c-.044-.2-.075-.408-.1-.575a1.671,1.671,0,0,1-.013-.278,2.2,2.2,0,0,1,.591-1.332,3.31,3.31,0,0,1,.5-.453,4.5,4.5,0,0,1,.509-.324,5.315,5.315,0,0,1,.608-.282c.14-.054.226-.079.226-.079l.438.079c.535.1,1.515.281,2.7.517h.017l.435.088c.331.066.672.137,1.021.211,3.051.641,6.668,1.509,7.657,2.188a.976.976,0,0,1,.091.076c.6.547,1.031,2.323,1.343,4.409C263.768,467.761,263.97,470.931,264.053,472.683Z",
    transform: "translate(-228.578 -423.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M197.125,314.111c-.61,1.088-1.244,1.949-3.579,2.354a34.4,34.4,0,0,0-5.37,1.378c-.623.189-2.415-2.095-3.269-4.132a30.979,30.979,0,0,1-1.535-5.282,4.422,4.422,0,0,1,2.712-4.552c0-.01,2.068,1.407,3.193.918,1.109-.481.653-1.31.639-1.333l2.984,2.929a36.943,36.943,0,0,0,1.482,4.438C195.609,313.655,197.293,313.811,197.125,314.111Z",
    transform: "translate(-169.532 -280.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M234.478,271.247a11.243,11.243,0,0,1,.18,1.329,3.479,3.479,0,0,1-2.419-1.527c.162-.087.326-.395.654-.569Z",
    transform: "translate(-214.714 -250.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M232.3,232.878s-2.831-.081-2.754-1.843-.235-2.96,1.575-2.982,2.133.665,2.25,1.259S233.043,232.853,232.3,232.878Z",
    transform: "translate(-212.227 -210.843)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M219.516,216.335a.946.946,0,0,1,.18-.367s-.208-.574.012-.7.338.361.434.268a2.41,2.41,0,0,0,.653-1.1c.129-.575,2.094-.171,2.326-.1a.311.311,0,0,0,.168-.012.644.644,0,0,0,.232-1.1c-.023-.02-.044-.041-.063-.06-.208-.209-1.653-1.619-3.307-.935s-1.773,1.536-1.578,2.226c.128.453.167,1.327.386,1.913a.294.294,0,0,0,.556-.026Z",
    transform: "translate(-202.014 -196.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M258.18,277.607a.922.922,0,0,0,.567.323.375.375,0,0,0,.466-.232A3.237,3.237,0,0,0,258.18,277.607Z",
    transform: "translate(-238.697 -256.655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M189.914,330.351a4.158,4.158,0,0,0-.032,2.736c.9,3.489,4.5,6.321,5.02,6.058s1.887-.226,1.148-1.811-3.728-7.434-3.728-7.434Z",
    transform: "translate(-175.373 -305.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M185,314.387a5.378,5.378,0,0,1-3.08.943,9.72,9.72,0,0,1-1.982-.215s-1.117-4.541.97-5.475c.718-.322,1.727-.69,1.727-.69S186.695,313.445,185,314.387Z",
    transform: "translate(-166.087 -285.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M263.309,427.332s-5.034-.537-5.71-.512-1.362,1.841-1.267,1.936a16.252,16.252,0,0,0,3.374.106,21.591,21.591,0,0,0,3.127-.54Z",
    transform: "translate(-236.98 -394.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M207.181,477.612a25.644,25.644,0,0,0-3.646-.743,27.052,27.052,0,0,0-3.735-.226q-.5,0-.991-.011c-.226-.008-.459-.018-.686-.031a22.664,22.664,0,0,1-3.463-.469l.054-1.951.183-6.728s.777-.255,1.841-.493c.215-.048.442-.1.679-.14h0a13.9,13.9,0,0,1,2.308-.264,3.3,3.3,0,0,1,2.641.8c.044.054.091.114.139.179.279.377.636.918,1.029,1.577.487.82,1.031,1.818,1.554,2.893.294.6.582,1.237.849,1.873A23.34,23.34,0,0,1,207.181,477.612Z",
    transform: "translate(-179.97 -431.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M75.784,349.011a27.047,27.047,0,0,0-3.735-.226q-.5,0-.991-.011c-.226-.008-.459-.018-.686-.031a22.667,22.667,0,0,1-3.463-.469c-6.087-1.319-10.868-5.231-10.395-12.035a26.062,26.062,0,0,1,.744-4.626q.151-.594.329-1.176h0q.34-1.114.772-2.178a2.759,2.759,0,0,1,.747,1.185c.727,2.268,2.022,6.325,3.371,10.565l.02.064.233.733c.008.025.015.05.023.076h0c0,.013.008.025.012.038l.236-.1h.008c.324-.135.69-.282,1.084-.433h0c.2-.075.417-.157.635-.236.617-.222,1.283-.442,1.962-.631.3-.085.6-.164.9-.233.385-.09.767-.166,1.14-.222l.032-.005.132-.018.042-.006h0c.248-.033.491-.057.725-.071h0c.142-.008.281-.013.417-.013a4.169,4.169,0,0,1,1.386.2,1.846,1.846,0,0,1,1,.775c.051.083.1.179.163.287.151.283.335.651.533,1.083h0c.3.663.647,1.477.989,2.374.3.775.592,1.61.86,2.464C75.318,347.095,75.586,348.074,75.784,349.011Z",
    transform: "translate(-52.219 -303.489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M67.871,328.241q-.432,1.062-.772,2.178h0q-.177.582-.329,1.176c1.023,3.969,2.6,10.026,2.6,10.026l.421-.112c.762-.2,2.309-.615,2.471-.644h.012c-1.45-4.553-2.882-9.02-3.66-11.445a2.738,2.738,0,0,0-.747-1.179Z",
    transform: "translate(-61.731 -303.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M274.277,459.081H267.75a.521.521,0,0,1,.52-.521h6.008Z",
    transform: "translate(-247.545 -423.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M323.546,371.25h10.092l-2.421,7.109H321.06Z",
    transform: "translate(-296.832 -343.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M335.6,371.25l-2.42,7.109H323.02l2.486-7.109Z",
    transform: "translate(-298.644 -343.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M405.418,411.461a.656.656,0,0,1-.6.492.378.378,0,0,1-.377-.492.657.657,0,0,1,.6-.491A.379.379,0,0,1,405.418,411.461Z",
    transform: "translate(-373.905 -379.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M1164.773,533.887l.029,4.951a.614.614,0,0,1-.609.616l-8.6.05a.613.613,0,0,1-.58-.405.6.6,0,0,1-.036-.2l-.029-4.949a.612.612,0,0,1,.608-.616l8.6-.05A.613.613,0,0,1,1164.773,533.887Z",
    transform: "translate(-1067.794 -493.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M1165.531,578.986a.613.613,0,0,1-.574.408l-8.6.05a.614.614,0,0,1-.579-.405l5.088-2.559Z",
    transform: "translate(-1068.562 -532.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M1164.819,533.887l-4.8,3.428L1155,534.2v-.253a.612.612,0,0,1,.608-.617l8.6-.05A.613.613,0,0,1,1164.819,533.887Z",
    transform: "translate(-1067.84 -493.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M1264,514.076a1.626,1.626,0,1,1,1.626,1.626A1.626,1.626,0,0,1,1264,514.076Z",
    transform: "translate(-1168.615 -473.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1277.713,522.231h-.006l-.347.165-.07-.32.484-.226h.35v1.822h-.411Z",
    transform: "translate(-1180.902 -482.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M321.541,689.3l.026,4.36a.548.548,0,0,1-.032.183.539.539,0,0,1-.5.359l-7.573.044a.539.539,0,0,1-.51-.356.528.528,0,0,1-.032-.18l-.026-4.358a.54.54,0,0,1,.536-.543L321,688.77A.539.539,0,0,1,321.541,689.3Z",
    transform: "translate(-289.278 -636.794)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M322.238,729.017a.539.539,0,0,1-.5.359l-7.573.044a.54.54,0,0,1-.51-.356l4.479-2.254Z",
    transform: "translate(-289.981 -671.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M321.559,689.267l-4.226,3.019-4.424-2.743v-.226a.54.54,0,0,1,.536-.543l7.573-.044a.539.539,0,0,1,.541.537Z",
    transform: "translate(-289.297 -636.757)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "w",
    cx: 1.432,
    cy: 1.432,
    r: 1.432,
    transform: "translate(30.856 50.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M421,679.063h0l-.306.146-.062-.281.427-.2h.309v1.605H421Z",
    transform: "translate(-388.888 -627.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M383.1,99.167c-.3-4.961-3.784-5.788-6.981-5.787s-6.324,1.66-6.172,5.391a5.526,5.526,0,0,0,1.585,4l-1.208,3.007,2.448-2.177a9.142,9.142,0,0,0,3.92.724C381.592,104.324,383.293,102.359,383.1,99.167Z",
    transform: "translate(-342.023 -86.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M265.241,69.111c.248-4.055,3.094-4.731,5.707-4.731s5.17,1.358,5.045,4.407a4.524,4.524,0,0,1-1.293,3.269l.981,2.459-2-1.78a7.531,7.531,0,0,1-3.2.592C266.473,73.326,265.082,71.72,265.241,69.111Z",
    transform: "translate(-245.214 -59.522)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M311.82,83.49c.679-.8,1.736-2.408,2.44-3.231a.261.261,0,0,0-.2-.431h-1.287l1.215-2.746a.108.108,0,0,0-.185-.108l-2.937,3.93a.163.163,0,0,0,.151.259l1.458-.18-.867,2.382a.125.125,0,0,0,.211.125Z",
    transform: "translate(-287.379 -71.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.336,
    height: 0.567,
    transform: "translate(60.387 4.923)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.229,
    height: 0.567,
    transform: "translate(68.444 4.923)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.772,
    height: 0.567,
    transform: "translate(60.387 6.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.841,
    height: 0.567,
    transform: "translate(66.378 6.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.885,
    height: 0.567,
    transform: "translate(60.387 7.967)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.664,
    height: 0.567,
    transform: "translate(65.394 7.967)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.628,
    height: 0.435,
    transform: "translate(31.125 11.023)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.477,
    height: 0.435,
    transform: "translate(37.306 11.023)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.661,
    height: 0.435,
    transform: "translate(31.125 12.191)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.947,
    height: 0.435,
    transform: "translate(35.721 12.191)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.98,
    height: 0.435,
    transform: "translate(31.125 13.358)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.578,
    height: 0.435,
    transform: "translate(34.966 13.358)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 0.789,
    cy: 0.789,
    r: 0.789,
    transform: "translate(38.34 78.126) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M549.394,396.5a95.5,95.5,0,0,1-6.9,11.581,14.807,14.807,0,0,1-3.966,4.075,9.518,9.518,0,0,0-2.964,2.7,21.593,21.593,0,0,0-3.086,6.334l-8.9-13.458a18.622,18.622,0,0,0,.685-5.328c-.014-2.939-.685-5.552.687-10.029,1.829-5.972,3.662-10.956,3.661-11.434a21.857,21.857,0,0,1,1.078-5.805,1.206,1.206,0,0,1,1.023-.4,1.593,1.593,0,0,1,1.373,1.3,14.789,14.789,0,0,1-.181,7.45c.336,3.39-.673,5.906.034,6.572.026.025.075.013.145-.031,1.226-.788,8.837-11.885,9.775-12.124C542.849,377.651,549.394,396.5,549.394,396.5Z",
    transform: "translate(-484.069 -346.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M340.639,880.112s-.035,1.717-.12,4.549c0,.151-.01.3-.014.453-.023.755-.05,1.578-.08,2.463-.054,1.579-3.773,13.591-3.855,15.5-3.292.136-18.534.076-23.38.076.312-.663,6.787-13.776,7.093-14.413,1.906-4.032,3.6-7.587,4.855-10.194h0c0-.007.006-.014.01-.02l.005-.011C326.5,875.7,327.32,874,327.32,874h.085a35.841,35.841,0,0,1,4.8.566l.377.075c2.786.563,5.913,1.612,7.315,3.554q.12.167.226.342a3.846,3.846,0,0,1,.377.866,3.729,3.729,0,0,1,.134.709Z",
    transform: "translate(-289.556 -808.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M836.736,347.079l-2.755,4.039-2.705,3.963a.618.618,0,0,1-.562.248c-.648-.061-1.451-1-2.077-1.515l-.063-.052a1.951,1.951,0,0,1-.259-2.739l4.132-4.995h0l1.226-1.481a1.952,1.952,0,0,1,2.74-.259l.063.052A1.952,1.952,0,0,1,836.736,347.079Z",
    transform: "translate(-765.396 -317.896)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M639.865,806.479a14.808,14.808,0,0,1-3.966,4.075,9.517,9.517,0,0,0-2.964,2.7c-.937-.437-2.007-.95-3.051-1.458a1.74,1.74,0,0,1-.075-3.094l.035-.02c1.167-.668,2.364-3.027,2.364-3.027Z",
    transform: "translate(-581.444 -744.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M594.9,382.7l-.721,2.91a1.525,1.525,0,0,0,1.035.057C595.619,385.466,595.95,382.856,594.9,382.7Z",
    transform: "translate(-549.341 -353.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M471.49,860.568s4.384,4.2,7.34,5.821l2.238-1.585v2.339s4.4.779,5.79,0v-6.386l-12.363-6.2Z",
    transform: "translate(-435.91 -790.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M457.892,804.24s-2.785,4.166-5.552,8.62c0,0,5.832,4.012,8.994,5.189l4.15-4.754-.592,5.719s3.671,1.338,5.373.989c0,0-.132-5.207-.131-8.609C470.132,811.4,460.067,808.591,457.892,804.24Z",
    transform: "translate(-418.205 -743.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 21.043,
    height: 39.613,
    rx: 10.522,
    transform: "translate(46.998 23.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M655.577,324.983v33.279a2.051,2.051,0,0,1-2.038,2.053H638.657a2.051,2.051,0,0,1-2.037-2.053V324.983a2.051,2.051,0,0,1,2.037-2.053h14.882A2.051,2.051,0,0,1,655.577,324.983Z",
    transform: "translate(-588.579 -298.561)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M653.539,322.93l-14.7,37.384h-.184a2.051,2.051,0,0,1-2.037-2.053V324.983a2.051,2.051,0,0,1,2.037-2.053Z",
    transform: "translate(-588.579 -298.561)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16.481,
    height: 6.023,
    rx: 3.011,
    transform: "translate(49.218 37.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M672.246,508.466a2.088,2.088,0,0,1-.213.92h0a2.1,2.1,0,0,1-.808.877c-.057.035-.117.066-.178.1h0a2.024,2.024,0,0,1-.386.138h0a2.092,2.092,0,0,1-2.059-.626c-.015-.017-.03-.033-.045-.051a2.093,2.093,0,1,1,3.689-1.354Z",
    transform: "translate(-617.646 -468.162)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 3.959,
    height: 0.459,
    transform: "translate(55.787 39.029)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 3.295,
    height: 0.229,
    transform: "translate(55.787 40.539)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(59.448 40.539)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(62.212 40.539)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(55.787 41.236)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(58.552 41.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M680.834,536.039a2.1,2.1,0,0,1-.807.875c-.057.035-.117.066-.178.1h0a2.029,2.029,0,0,1-.386.138h0a10.98,10.98,0,0,1-1.376-.472,2.266,2.266,0,0,1-.5-.276l0,0h0l.024-.008a.618.618,0,0,0,.168-.075h0a.671.671,0,0,0,.287-.412,1.77,1.77,0,0,0,.039-.44c0-.032-.015-.174-.018-.208h0c.063-.033.192.014.317-.053l.6.291h.005a.01.01,0,0,0,0,0,.039.039,0,0,0,0,.008h0v.011c0,.014.007.032.011.057a.075.075,0,0,0,0,.013v.011l0,.026c0,.017.006.036.008.057a.11.11,0,0,1,0,.028v.011a.121.121,0,0,0,.005.042.294.294,0,0,1,.007.054l0,.043a.108.108,0,0,0,0,.034.1.1,0,0,1,0,.035v.036a.128.128,0,0,0,0,.038h0a.161.161,0,0,0,.167.151h.019c.151-.025.39-.066.653-.119A4.129,4.129,0,0,1,680.834,536.039Z",
    transform: "translate(-626.448 -494.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M701.285,545.869a5.1,5.1,0,0,0-.777-.031,6.628,6.628,0,0,0-.808.142h0l.6.859h0c.061-.029.121-.061.178-.1a2.1,2.1,0,0,0,.806-.875Z",
    transform: "translate(-646.899 -504.645)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M677.075,547.76l.779.766c-.057.035-.117.066-.178.1h0a2.028,2.028,0,0,1-.386.138h0a2.092,2.092,0,0,1-2.059-.626,1.606,1.606,0,0,1,.182-.121l.023-.012a1.344,1.344,0,0,1,.151-.075h.023c.032.021.8.534,1.222.35s.26-.483.246-.509Z",
    transform: "translate(-624.275 -506.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M686.037,535.4a4.35,4.35,0,0,1,.069.509,1.341,1.341,0,0,1-.927-.585c.062-.033.125-.151.251-.218Z",
    transform: "translate(-633.474 -494.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M685.19,520.734s-1.084-.031-1.057-.706-.091-1.132.6-1.143.817.254.862.482S685.473,520.725,685.19,520.734Z",
    transform: "translate(-632.506 -479.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M680.316,514.394a.363.363,0,0,1,.069-.14s-.08-.22,0-.269.13.138.167.1a.923.923,0,0,0,.25-.423c.05-.22.8-.066.891-.039a.114.114,0,0,0,.064,0,.247.247,0,0,0,.09-.42l-.024-.023a1.229,1.229,0,0,0-1.267-.358c-.634.262-.679.589-.6.852a6.958,6.958,0,0,0,.151.733.112.112,0,0,0,.209-.01Z",
    transform: "translate(-628.619 -474.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M695.12,537.842a.353.353,0,0,0,.217.124.143.143,0,0,0,.179-.088A1.245,1.245,0,0,0,695.12,537.842Z",
    transform: "translate(-642.664 -497.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M675.721,550.913a2.091,2.091,0,0,1-1.026-.622c-.015-.017-.03-.033-.045-.051.174-.071.34-.133.4-.151h.023c.011.013.141.158.306.367A4.058,4.058,0,0,1,675.721,550.913Z",
    transform: "translate(-623.739 -508.579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16.481,
    height: 6.023,
    rx: 3.011,
    transform: "translate(49.218 45.222)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M672.255,613.533a2.088,2.088,0,1,1-.612-1.481A2.093,2.093,0,0,1,672.255,613.533Z",
    transform: "translate(-617.656 -565.299)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 3.959,
    height: 0.459,
    transform: "translate(55.787 46.958)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 3.295,
    height: 0.229,
    transform: "translate(55.787 48.467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(59.448 48.467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(62.212 48.467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(55.787 49.165)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(58.552 49.165)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M677.407,656.578a2.091,2.091,0,0,1-2.787-.372,1.629,1.629,0,0,1,.566-.068h.045c.438.027.86-.006,1.228.019a1.2,1.2,0,0,1,.94.409l.008.012Z",
    transform: "translate(-623.711 -606.622)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.475 46.535)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M683.264,639.758a1.553,1.553,0,0,1-1.144-.342,1.77,1.77,0,0,0,.443-1.366l.508.409.344.278a4.016,4.016,0,0,1-.038.453c0,.029-.008.061-.014.094a.248.248,0,0,0,.106.239C683.669,639.657,683.415,639.74,683.264,639.758Z",
    transform: "translate(-682.12 -636.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M688.814,643.655a3.989,3.989,0,0,1-.038.453c-.383-.066-.816-.684-.816-.684a1.228,1.228,0,0,1,.51-.045Z",
    transform: "translate(-687.519 -641.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M686.107,624.962s-1.084.18-1.186-.5-.31-1.109.377-1.253.862.094.951.312S686.383,624.9,686.107,624.962Z",
    transform: "translate(-684.607 -622.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M682.981,618.389s.111-.019.093-.172-.017-.354.107-.316.131.137.182.076.052-.3.423-.321.521.112.693.036.182-.337.182-.337a.3.3,0,0,1-.124.123s.288-.394-.045-.663-.672-.094-.865-.082c-.425.026-.7.051-.838.33A1.54,1.54,0,0,0,682.981,618.389Z",
    transform: "translate(-682.672 -616.666)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16.481,
    height: 6.023,
    rx: 3.011,
    transform: "translate(49.218 53.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 3.959,
    height: 0.459,
    transform: "translate(55.787 54.886)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 3.295,
    height: 0.229,
    transform: "translate(55.787 56.396)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(59.448 56.396)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(62.212 56.396)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(55.787 57.094)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(58.552 57.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M672.255,718.6a2.093,2.093,0,1,1-2.093-2.093,2.092,2.092,0,0,1,2.093,2.093Z",
    transform: "translate(-617.656 -662.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M679.039,722.684a.583.583,0,0,0-.182.816s-.413-.075-.5-.2a.292.292,0,0,0,.026.075,1.145,1.145,0,0,1-.5-.244c-.127-.158.485-2.056,1.471-1.564a.793.793,0,0,1,.549,1.169c-.356,1-.02,1.09-.02,1.09a.488.488,0,0,1-.151.009s-.059-.042-.062-.081a.236.236,0,0,0,.01.082.985.985,0,0,1-.514-.245A1.162,1.162,0,0,1,679.039,722.684Z",
    transform: "translate(-626.707 -667.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M684.439,758.72Z",
    transform: "translate(-632.788 -701.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M685.606,744.17c.014.125.03.236.038.289.017.119-1.112.042-1.184.042a3.141,3.141,0,0,0,.252-.693c.058-.226.1-.468.1-.468l.8.051h.048a2.727,2.727,0,0,0-.065.306.086.086,0,0,1-.006.038A2.071,2.071,0,0,0,685.606,744.17Z",
    transform: "translate(-632.809 -687.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M686.422,724.3a2.316,2.316,0,0,1-.1-.724.79.79,0,0,1,1.106-.664,1.116,1.116,0,0,1,.4.289c.142.163.325.481-.137,1.1l-.135.215Z",
    transform: "translate(-634.524 -668.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M689.924,744.457a1.4,1.4,0,0,1-.794-.807,1.707,1.707,0,0,1,.784.336.086.086,0,0,1-.006.039A2.071,2.071,0,0,0,689.924,744.457Z",
    transform: "translate(-637.126 -687.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M689.63,728.778s-1.007-.249-.842-.874.146-1.078.8-.946.712.4.707.626S689.9,728.827,689.63,728.778Z",
    transform: "translate(-636.793 -672.079)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M687.321,723.908a1.046,1.046,0,0,0-.659-.524c-.256-.172-.595.25-.595.25a1.235,1.235,0,0,1-.577.6.857.857,0,0,0,.6.165.74.74,0,0,0,.4-.146,2.425,2.425,0,0,1-.533.386,1.71,1.71,0,0,0,.985-.8.887.887,0,0,1,.151.337c.008.173-.056.506.042.52C687.14,724.695,687.522,724.228,687.321,723.908Z",
    transform: "translate(-633.761 -668.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M698.09,745.994s.013.1.076.118a.882.882,0,0,0,.238.053.74.74,0,0,0,.075-.084A1.346,1.346,0,0,0,698.09,745.994Z",
    transform: "translate(-645.41 -689.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M678.748,753.583a2.09,2.09,0,0,1-2.838-.151c.207-.173.5-.343.617-.448a.312.312,0,0,0,.075-.226c-.01-.063.063-.168.122-.151h.013a1.278,1.278,0,0,0,.666.134.731.731,0,0,0,.151-.068.688.688,0,0,1,.138-.062.168.168,0,0,1,.088,0c.137.038-.008.367.069.371.107.005.588.013.734.214A1.487,1.487,0,0,1,678.748,753.583Z",
    transform: "translate(-624.904 -695.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M674.711,758.639a2.094,2.094,0,0,1-.946-.561,2.069,2.069,0,0,1-.175-.2,2.176,2.176,0,0,1,.792-.244l.027.084h0Z",
    transform: "translate(-622.759 -700.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16.481,
    height: 6.023,
    rx: 3.011,
    transform: "translate(49.218 29.365)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 3.959,
    height: 0.459,
    transform: "translate(55.787 31.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 3.959,
    height: 0.459,
    transform: "translate(60.348 31.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 3.295,
    height: 0.229,
    transform: "translate(55.787 32.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(59.448 32.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(62.212 32.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(55.787 33.308)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 2.289,
    height: 0.229,
    transform: "translate(58.552 33.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M671.762,403.695a2.092,2.092,0,0,1-2.222,1.954,2.134,2.134,0,0,1-.377-.059h0a2.09,2.09,0,0,1-.872-.461,1.966,1.966,0,0,1-.218-.223,2.093,2.093,0,1,1,3.689-1.211Z",
    transform: "translate(-617.203 -371.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M672.729,406.153a.657.657,0,0,0-.516-.09c-.877-.16-1.2.853-1.207,1.207a1.464,1.464,0,0,1-.42,1.174,1.841,1.841,0,0,0-.206.248,2.064,2.064,0,0,0,.288.445,1.963,1.963,0,0,0,.211.223,2.09,2.09,0,0,0,.869.458.685.685,0,0,1,.887-.569c.227.04.4.136.377.176a.92.92,0,0,0,.34.048.436.436,0,0,0,.4-.334A4.064,4.064,0,0,0,672.729,406.153Z",
    transform: "translate(-619.791 -375.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M674.745,439.44a2.018,2.018,0,0,1-.417-.285,1.964,1.964,0,0,1-.218-.223c.044-.081.076-.143.1-.176a1.041,1.041,0,0,1,.542-.487Z",
    transform: "translate(-623.24 -405.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M679.51,438.439a2.086,2.086,0,0,1-1.259.325,2.142,2.142,0,0,1-.377-.059h0a2.09,2.09,0,0,1-.873-.46,4.692,4.692,0,0,1,.421-.885,1.977,1.977,0,0,1,.429-.067,3.821,3.821,0,0,1,.8.035q.2.027.42.075l.4.952Z",
    transform: "translate(-625.912 -404.287)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M688.838,429.884a1.748,1.748,0,0,1-.053-.644l-.04.005-.675.089s0,.211-.01.408v.008c-.011.171-.138.336.133.422C688.277,430.2,688.944,430.2,688.838,429.884Z",
    transform: "translate(-636.101 -396.848)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M688.551,429.4s0,.211-.01.408a.787.787,0,0,0,.685-.5Z",
    transform: "translate(-636.581 -396.913)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M684.008,414.812s.881.072.917-.478.174-.91-.387-.981-.684.134-.74.314S683.78,414.78,684.008,414.812Z",
    transform: "translate(-632.175 -382.147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M688.58,411.81s.2.66.564.779a.737.737,0,0,0,.532.03,1.047,1.047,0,0,1-.3-.641S688.782,411.518,688.58,411.81Z",
    transform: "translate(-636.618 -380.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M683.6,412.369a.551.551,0,0,0-.266.182.893.893,0,0,0-.151.5s-.151-.453.067-.684C683.486,412.114,683.6,412.369,683.6,412.369Z",
    transform: "translate(-631.585 -381.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M700.091,440.237c-.051-.06-.106-.123-.166-.191a.444.444,0,0,1-.01-.368,3.863,3.863,0,0,1,.311-.727,1.071,1.071,0,0,1,.8.618c.009.02.017.042.025.065a.066.066,0,0,0,.008.023A2.1,2.1,0,0,1,700.091,440.237Z",
    transform: "translate(-647.067 -405.826)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M681.935,362.336l-.292.209-.293-.207a.358.358,0,0,1,.585,0Z",
    transform: "translate(-629.933 -334.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M676.539,355.41a.866.866,0,0,0-.709.369l.185.13a.642.642,0,0,1,1.047,0l.184-.132A.867.867,0,0,0,676.539,355.41Z",
    transform: "translate(-624.83 -328.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M666.823,342.55a1.837,1.837,0,0,0-1.5.78l.186.131a1.611,1.611,0,0,1,2.628-.01l.184-.133A1.837,1.837,0,0,0,666.823,342.55Z",
    transform: "translate(-615.113 -316.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M672.074,349.59a1.311,1.311,0,0,0-1.074.553l.185.131a1.088,1.088,0,0,1,1.768-.007l.183-.132A1.311,1.311,0,0,0,672.074,349.59Z",
    transform: "translate(-620.364 -323.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M733.19,664.731l-12.233,1.832-2.807.014s-4.528-2.982-6.286-5.145a59.716,59.716,0,0,1-2.512-6.867c-.59-1.807-1.069-3.353-1.151-3.707a57.459,57.459,0,0,1,.014-5.979v-.032c.041-1.287.082-2.331.092-2.566v-.05h0a1.68,1.68,0,0,1,1.755.3c.981.7,1.66,5.5,1.933,6.36.267.835,3.417,4.509,3.614,4.738l.009.011v-5.8l-3.844-10.286s-2.785-4.572-2.134-6.706a1.087,1.087,0,0,1,1.146-.881,1.019,1.019,0,0,1,.119.01.807.807,0,0,1,.572.346s2.692,3.513,3.058,4.027c.817,1.152,3.019,4.905,3.019,4.905l2.579.108a1.715,1.715,0,0,1,1.1.459c.917.857,2.893,2.709,3.135,2.985h0c.3.31,3.612,1.727,5.177,3.109h0a2.853,2.853,0,0,1,.718.869C731.007,648.4,733.19,664.731,733.19,664.731Z",
    transform: "translate(-654.692 -582.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M833.08,753.05a48.011,48.011,0,0,0,2.7,4.075c.316.177,1.546.421,1.686,0S833.08,753.05,833.08,753.05Z",
    transform: "translate(-770.213 -696.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M928.54,803.272c-.029-.008-1.705-.467-2.437-.628s-2.653-2.381-2.743-2.484C923.645,800.466,926.97,801.884,928.54,803.272Z",
    transform: "translate(-853.681 -739.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M807.41,872.612v-5.8a12.232,12.232,0,0,1,1.484,3.57C809,871.644,808.321,873.691,807.41,872.612Z",
    transform: "translate(-746.481 -801.398)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M732.5,632.106a10.41,10.41,0,0,1-.686-1.322.66.66,0,0,1,.091-.509,1.141,1.141,0,0,1,.361-.377,1.184,1.184,0,0,1,.254-.137.979.979,0,0,1,.325-.06.346.346,0,0,1,.277.161h0a10.058,10.058,0,0,1,.747,1.253.641.641,0,0,1-.11.789l-.1.071-.5.362C732.962,632.491,732.664,632.388,732.5,632.106Z",
    transform: "translate(-676.572 -582.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M732.5,635.8a10.411,10.411,0,0,1-.686-1.322.659.659,0,0,1,.091-.509,1,1,0,0,1,.1-.075,1.221,1.221,0,0,1,.254-.137.993.993,0,0,1,.325-.06.345.345,0,0,1,.278.161h0a9.967,9.967,0,0,1,.748,1.252.765.765,0,0,1,.05.564l-.5.362A.472.472,0,0,1,732.5,635.8Z",
    transform: "translate(-676.572 -585.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M740.669,965.477l-4.734,2.451-2.807.014s-4.528-2.982-6.286-5.145a59.714,59.714,0,0,1-2.512-6.867h0c.126.384,2.765,6,3.516,6.641s4.7,4.358,5.786,4.32S740.577,965.5,740.669,965.477Z",
    transform: "translate(-669.67 -883.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M840.93,1074.87s11.141-4.5,14.875-2.966c0,0,3.194,8.781,5.438,13.849-6.659,0-17.633.037-17.633.037Z",
    transform: "translate(-777.471 -990.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M709.355,792.455l-.1,2.648a1.357,1.357,0,0,0,.873-.146C710.449,794.721,710.283,792.421,709.355,792.455Z",
    transform: "translate(-655.737 -732.654)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.80579cecd64d3d5818b83d5805aee79a.svg";
export { ForwardRef as ReactComponent };